import blidzPlusGoldImg from "~/assets/blidz-plus-gold.png";

interface BlidzPlusBadgeProps {
  className?: string;
  showBlidzText?: boolean;
  text?: string;
}

export default function BlidzPlusBadge({ className = "", showBlidzText = true, text }: BlidzPlusBadgeProps) {
  const displayText = text ?? (showBlidzText ? "Blidz Plus" : "Plus");

  return (
    <div
      className={`inline-flex items-center justify-center gap-0.5 rounded-lg border border-black/10 bg-[#171717] px-2 py-0.5 ${className}`}
    >
      <img src={blidzPlusGoldImg} alt="Plus" className="h-3.5 w-3" />
      <span
        className="bg-gradient-to-r from-[#FFFBE0] to-[#FDF853] bg-clip-text text-xs leading-[1.5] font-bold whitespace-nowrap text-transparent"
        style={{ fontFamily: "Figtree" }}
      >
        {displayText}
      </span>
    </div>
  );
}
